/**
 * Uses the the prefix for the CSS variables compiled by the system.
 */
export var NAMESPACE = '--wp-g2';
export var DARK_MODE_ATTR_PROP = 'data-system-ui-mode';
export var HIGH_CONTRAST_MODE_ATTR_PROP = 'data-system-ui-contrast-mode';
export var COLOR_BLIND_MODE_ATTR_PROP = 'data-system-ui-color-blind-mode';
export var REDUCED_MOTION_MODE_ATTR_PROP = 'data-system-ui-reduced-motion-mode';
export var DARK_MODE_ATTR = "[" + DARK_MODE_ATTR_PROP + "=\"dark\"]";
export var HIGH_CONTRAST_MODE_MODE_ATTR = "[" + HIGH_CONTRAST_MODE_ATTR_PROP + "=\"high\"]";
export var COLOR_BLIND_MODE_ATTR = "[" + COLOR_BLIND_MODE_ATTR_PROP + "=\"true\"]";
export var REDUCED_MOTION_MODE_ATTR = "[" + REDUCED_MOTION_MODE_ATTR_PROP + "=\"true\"]";
export var DARK_HIGH_CONTRAST_MODE_MODE_ATTR = "" + DARK_MODE_ATTR + HIGH_CONTRAST_MODE_MODE_ATTR;
export var MODE_SPECIFICITY_COMPOUND_LEVEL = 3;